import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import createMantisTheme from './themes';
import landingTheme from './apps/public/themes/landingTheme';
import './i18n/config';

// Determine app type from environment
const APP_TYPE = import.meta.env.VITE_APP_TYPE || 'admin';

// Lazy load components
import AdminApp from './apps/admin/AdminApp';
import LiffApp from './apps/liff/LiffApp';
import PublicApp from './apps/public/PublicApp';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// Select theme based on app type
const getTheme = () => {
  if (APP_TYPE === 'public' || APP_TYPE === 'liff') {
    return landingTheme;
  }
  return createMantisTheme('light');
};

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={getTheme()}>
        <CssBaseline />
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          {APP_TYPE === 'liff' ? <LiffApp /> : APP_TYPE === 'public' ? <PublicApp /> : <AdminApp />}
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
